// A star rating as shown on the site. It never rounds up, so a stored 4.95
// reads "4.95", not "5.0". Whole and one-decimal ratings keep one decimal
// place ("5.0", "4.9") so every badge reads alike.
export function formatRating(value) {
  const hundredths = Math.floor(Number(value) * 100 + 1e-6);
  return (hundredths / 100).toFixed(hundredths % 10 === 0 ? 1 : 2);
}
